import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { CommonService } from '../../service/common.service';
import { Azienda } from '../../models/azienda';
import { Orfricliente } from '../../models/orfricliente';
import { configurazione } from '../../../configurazioni/configurazione';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { SelectionModel } from '@angular/cdk/collections';

@Component({
  selector: 'app-addevento',
  templateUrl: './addevento.component.html',
  styleUrls: ['./addevento.component.css']
})
export class AddeventoComponent implements OnInit {
  titolo: string;
  orainizio: string;
  orafine: string;
  aziende: Array<Azienda>=[];
  azienda: Azienda=new Azienda();
  selectedAzienda: Azienda;
  aziendeselezionate: Azienda[]=[];
  orfriclienti: Orfricliente[]=[];
  displayedColumns: string[] = [
  "sel",
  "Codice",
  "Nome",
  "Partitaiva",
  "Codicefiscale",
  "Email",
  "Ragionesociale",
  ]; 

  tipievento:Tipoevento[];
  selectedValueTipoevento: string='';

  sortedDirection:Map<string, boolean>=new Map<string, boolean>();

  dataSource = new MatTableDataSource<Azienda>(this.aziende);
  @ViewChild('paginator') paginator: MatPaginator;
  selection = new SelectionModel<Azienda>(true, []);

  constructor(public dialogRef: MatDialogRef<AddeventoComponent>, private router: Router,
    private commonService: CommonService, private httpClient: HttpClient,
              @Inject(MAT_DIALOG_DATA) public data: {aziende: Azienda[]}) {

    this.commonService.getAllAziendeByTiporelazione(2).subscribe(response => {
      this.aziende = response;
     this.dataSource = new MatTableDataSource<Azienda>(this.aziende);
      this.dataSource.paginator = this.paginator; 
    });
    //  this.aziende=this.data.aziende;
    //  this.dataSource = new MatTableDataSource<Azienda>(this.aziende);
     // this.dataSource.paginator = this.paginator;

      this.tipievento=[];
      this.tipievento.push(new Tipoevento(''));
      this.tipievento.push(new Tipoevento('ATP'));
      this.tipievento.push(new Tipoevento('Collaudo'));
      this.tipievento.push(new Tipoevento('Assistenza'));

    }

    ngOnInit(): void {

      this.sortedDirection.set("Nome",true);
      this.sortedDirection.set("Partitaiva",true);
      this.sortedDirection.set("Codicefiscale",true);
      this.sortedDirection.set("Email",true);
      this.sortedDirection.set("Ragionesociale",true);


  }

  manageCheckboxclick(event, a:Azienda){
    this.aziendeselezionate=[];
    this.azienda=a;
    let found:boolean=false;
    this.selection.selected.forEach(row => {
      if (row.Codice!=a.Codice){
        this.selection.deselect(row);
      }else{
        found=true;
        this.aziendeselezionate.push(a);
      }
    });
    if (!found){
      this.azienda=new Azienda();
      this.aziendeselezionate=[];
    }
    event.stopPropagation();
    if (this.aziendeselezionate.length>0){
      let a:Azienda=this.aziendeselezionate[0];
      if (a.Email===undefined || a.Email===null || a.Email===''){
        alert("E' necessario indicare un indirizzo email per l'azienda selezionata");
//      this.customdataAzienda(this.aziendeselezionate[0]);
      }
    }
  }

  editAzienda(azienda: Azienda): void {
      this.commonService.selectedAzienda=azienda;
      this.router.navigate(['addazienda']);
  }

/*
  customdataAzienda(azienda: Azienda){
    this.azienda=azienda;
    if (this.commonService.currentIstanza!=undefined){
      if (this.commonService.currentIstanza.Codice === 1){

      }else if (this.commonService.currentIstanza.Codice === 2){

      }else if (this.commonService.currentIstanza.Codice === 3){

      }else if (this.commonService.currentIstanza.Codice === 4){

      }else if (this.commonService.currentIstanza.Codice === 5){

      }else if (this.commonService.currentIstanza.Codice === 6){

         this.commonService.getAllOrfriclientiByAzienda(azienda.Codice).subscribe(res => {
           this.orfriclienti=res;
       });
      }else if (this.commonService.currentIstanza.Codice === 7){

      }
    }
   }
*/

manageChangeEmail(value:any){
  this.azienda.Email=value.target.value;
}
enableSave(): boolean{

    if (this.aziendeselezionate.length>0){
      let a:Azienda=this.aziendeselezionate[0];
      if (a.Email===undefined || a.Email===null || a.Email===''){
          return false;
      }else{

    //    const regExp = new RegExp(/^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$/);

        const regExp = new RegExp(/^[^@\s]+@[^@\s]+\.[^@\s]+$/);

        if (!regExp.test(a.Email)){
          return false;
        }

        if ((this.titolo===undefined) || (this.orainizio===undefined) || (this.orafine===undefined)){
          return false;
        }else{
          if ((this.titolo!='') && (this.orainizio!='') && (this.orafine!='')){
            return this.checkHourIsValid(this.orainizio, this.orafine);
          } else {
            return false;
          }
        }
      }
    }else{
      return false;
    }
  }
  manageClick(attributo: string){
    //alert(ev.target)
/*
    switch (_case) {
         case 'number':
           this.elements2.sort((a, b) => {
             return a.position - b.position;
           });
           break;
         case 'text':
  */
    let tempList:Azienda[];
    tempList=this.aziende;
    let direction=this.sortedDirection.get(attributo);

    tempList.sort((a, b) => {
       var typeA = "";
       var typeB = "";
       if (a[attributo]!=null){
         if (isNaN(b[attributo]))
            typeA = a[attributo].toLowerCase();
         else
            typeA = a[attributo].toString();
       }
       if (b[attributo]!=null){
         if (isNaN(b[attributo]))
            typeB = b[attributo].toLowerCase();
          else
            typeB = b[attributo].toString();
       }
         if (direction){
           if (typeA > typeB){
             return -1;
           }else if (typeA < typeB){
              return 1;
           }else{
             return 0;
           }
         }else{
           if (typeA < typeB){
             return -1;
           }else if (typeA > typeB){
              return 1;
           }else{
             return 0;
           }
         }
     });
     direction=!direction;
     this.sortedDirection.set(attributo,direction);

     this.dataSource = new MatTableDataSource<Azienda>(this.aziende);

   }

  getConfigurazione(){
    if (this.commonService.currentIstanza!=undefined){
      if (this.commonService.currentIstanza.Codice === 1){
        return configurazione.azienda.fb;
      }else if (this.commonService.currentIstanza.Codice === 2){
        return configurazione.azienda.fb;
      }else if (this.commonService.currentIstanza.Codice === 3){
        return configurazione.azienda.fb;
      }else if (this.commonService.currentIstanza.Codice === 4){
        return configurazione.azienda.fb;
      }else if (this.commonService.currentIstanza.Codice === 5){
        return configurazione.azienda.fb;
      }else if (this.commonService.currentIstanza.Codice === 6){
        return configurazione.azienda.orfri;
      }else if (this.commonService.currentIstanza.Codice === 7){
        return configurazione.azienda.fb;
      }
    }
    return configurazione.azienda.fb;
  }

  checkHourIsValid(oinizio:string, ofine:string):boolean{
    /*
    const parts = d.split('/');
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10);
    const year = parseInt(parts[2], 10);
   */
    const inizioparts = oinizio.split(':');
    const orainizio = parseInt(inizioparts[0]);
    const minutiinizio = parseInt(inizioparts[1]);
    const fineparts = ofine.split(':');
    const orafine = parseInt(fineparts[0]);
    const minutifine = parseInt(fineparts[1]);

    if (isNaN(orainizio)||isNaN(minutiinizio)||isNaN(orafine)||isNaN(minutifine)){
      alert('Gli orari devono essere numerici');
      return false;
     }else if (orafine<orainizio){
    //  alert('Ora di fine deve essere maggiore di quella di inizio');
      return false;
     }else if ((orafine===orainizio)&&(minutifine<minutiinizio)){
    //  alert('Minuti di fine devono essere maggiori di quelli di inizio');
      return false;
    }
    //console.log("------"+orainizio+" "+orafine);
    return true;
  }

  dataIsValid(d:Date):boolean{
    if (d!=undefined){
       const regExp = new RegExp(/^(((0[1-9]|[12]\d|3[01])\/(0[13578]|1[02])\/((19|[2-9]\d)\d{2}))|((0[1-9]|[12]\d|30)\/(0[13456789]|1[012])\/((19|[2-9]\d)\d{2}))|((0[1-9]|1\d|2[0-8])\/02\/((19|[2-9]\d)\d{2}))|(29\/02\/((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00))))$/);
        //  if (regExp.test(controls.value)) {
        //    return null;
        //  } else {
        //    return { 'validateDate': true }
        //  }
        return regExp.test(d.toString()) ? false : true;
      }
      return false;
  }

}

class Tipoevento{
  Nome: string;
  constructor(n:string){
    this.Nome=n;
  }
}
